export default "__VITE_ASSET__BzwWsxpA__"